/**
 * Formats a document as CPF (when 11 or fewer characters) or CNPJ
 * (when more than 11 characters).
 *
 * The CNPJ branch follows IN RFB nº 2.229/2024, accepting uppercase letters
 * in positions 1-12. Input is sanitized via `sanitizeCnpj` which strips
 * non-alphanumeric characters and uppercases letters.
 *
 * This helper is the bridge that lets us emulate `v-mask="documentMask"`
 * via a Vue watcher without relying on the `N` token registration in
 * `vue-the-mask`, which proved unreliable in production bundles for some
 * v-text-field render paths.
 *
 * @param {string|null|undefined} value
 * @returns {string} formatted document or empty string
 */
import { CNPJ_MASK, sanitizeCnpj } from '@/helpers/cnpj'

const CPF_MASK = '###.###.###-##'
const CPF_LENGTH = 11

const applyMask = (raw, mask) => {
  let output = ''
  let cursor = 0
  for (const maskChar of mask) {
    if (cursor >= raw.length) break
    if (maskChar === 'N' || maskChar === '#') {
      output += raw[cursor]
      cursor++
    } else {
      output += maskChar
    }
  }
  return output
}

export const formatCpfOrCnpj = value => {
  if (value === null || value === undefined || value === '') return ''
  const raw = sanitizeCnpj(value)
  if (!raw) return ''
  const mask = raw.length <= CPF_LENGTH ? CPF_MASK : CNPJ_MASK
  return applyMask(raw, mask)
}

export const sanitizeCpfOrCnpj = sanitizeCnpj
